import classNames from "classnames";

import { Button } from "primereact/button";
import { Menu } from "primereact/menu";
import { createRef, useState } from "react";
import { useForm } from "react-hook-form";
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { TbSunMoon } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { ImagemCapa, ImagemLogoReverse } from "../../components/imagensDinamicas";
import { useTheme } from "../../context/themeContext";
import { Api } from "../../services/api";
import { MenuPague } from "../../styles/primeReactConfig";
import { setLocal } from "../../utils/localStorageOps";

function Login() {
  const menuRef = createRef()
  const { itemsTheme } = useTheme()
  const [revelaSenha, setRevelaSenha] = useState(false)
  const navigate = useNavigate();
  const { register, handleSubmit } = useForm();

  function toggleMenu(e) {
    if (!menuRef.current) {
    } else menuRef.current.toggle(e);
  }


  const onSubmit = async (values) => {
    if (!values.email || !values.senha) {
      return toast.error('Por favor, informe seu e-mail e senha.');
    }
    // setIsLoading(true);
    // console.log(values)

    try {
      const { data } = await Api.post('login', {
        usuario_email: values.email,
        password: values.senha,
      });

      
      setLocal('cartorio_provider', data.cartorio_provider);
      
      if (data.possuiParceiros) {
        setLocal('parceiro', data.possuiParceiros.parametros_parceiro)
      } else setLocal("parceiro", false);
      
      if (data.data_associado) {
        // console.log(data.data_associado)
        setLocal('associado_id', data.data_associado.associado_id);
        setLocal('associado', data.associado);
      }

      setLocal('userzoop', data.usuario_zoop_id);
      setLocal('username', data.usuario_nome);
      setLocal('iduser', data.usuario_id);
      setLocal('documentouser', data.usuario_documento);

      setLocal("token", data.token);
      navigate('/dashboard');
      window.location.reload();
      setLocal('protesto', false);
      return (
        'null'
      )


    } catch (error) {
      console.log(error.response);
      if (error.response === undefined)
        return toast.error("O sistema está fora do ar, tente novamente mais tarde");
      if (error.response.status === 403)
        return toast.error('Senha incorreta, verifique seus dados');
      if (error.response.status === 401)
        return toast.error('Usuário bloqueado');
      if (error.response.status === 404)
        return toast.error('E-mail inexistente, verifique seus dados')
      if (error.response.status === 500)
        return toast.error("O sistema está fora do ar, tente novamente mais tarde");
      else
        return toast.error("O sistema está fora do ar, tente novamente mais tarde");
    }
  }


  return (
    <div className=" h-screen w-screen flex 
    dark:bg-pague_azul bg-[#f1f2f3]">
      <div className="w-1/2 h-full relative lg:flex hidden"
      >
        <ImagemCapa />
      </div>
      <div className="h-full w-full md:w-1/2 flex flex-col justify-center
      p-[5%] gap-5 dark:text-zinc-700 text-zinc-100">
        <div className="h-auto w-auto flex justify-center items-center">
          <ImagemLogoReverse />
          <Button
            pt={{
              root: classNames(
                "rounded-full bg-black text-white ",
                "dark:text-black dark:bg-white",
                "flex items-center justify-center w-6 h-6",
              ),
              label: "absolute"
            }}
            onClick={toggleMenu}
            icon={<TbSunMoon />}
          />
          <Menu
            popup
            ref={menuRef}
            model={itemsTheme}
            pt={MenuPague}
          />
        </div>
        <div className="flex justify-center w-full">
          <div className="w-3/4 h-auto dark:bg-white 
          bg-pague_azul p-[5%] rounded-lg
          grid gap-4">
            <h4 className="text-center text-2xl font-semibold">
              Acesse sua conta
            </h4>
            <form className="gap-4 flex flex-col text-lg"
              onSubmit={handleSubmit(onSubmit)}>
              <div>
                <h4>E-mail</h4>
                <input
                  type="email"
                  id="email"
                  className="border-slate-300 border-2 
                rounded-md w-full h-auto py-1 px-2
                text-black "
                  {...register("email", {
                    required: "Email é obrigatório.",
                    pattern: {
                      value: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
                      message: "Formato de email inválido."
                    }
                  })}
                />
              </div>
              <div>
                <h4>Senha</h4>
                <span className="flex w-full 
                  border-slate-300 border-2 rounded-md">
                  <input
                    type={!revelaSenha ? "password" : 'text'}
                    id="senha"
                    className="text-black
                  w-full h-auto py-1 px-2"
                    {...register("senha", {
                      required: "Senha é obrigatória."
                    })}
                  >
                  </input>
                  <span className="bg-white text-3xl p-1
                   text-sky-800 cursor-pointer"
                    onClick={() => setRevelaSenha(prevState => !prevState)}
                  >
                    {!revelaSenha ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </span>
              </div>
              <div className="w-full pt-4 grid">
                <button className='dark:bg-pague_azul bg-pague_verde
              text-white 
              hover:dark:bg-sky-900 hover:bg-pague_verde_claro
              transition-colors duration-300
              py-3  rounded-lg text-xl font-bold'
                  type="submit"
                >
                  Entrar
                </button>
              </div>
            </form>
            <div className="text-center text-md">
              <h4>Ainda não possui conta? <a href='/cadastro/passo0'
                className="underline dark:text-blue-700 text-blue-300">
                Cadastre-se aqui
              </a></h4>
              <h4>Esqueceu sua senha? <a href='/resetsenha'
                className="underline dark:text-blue-700 text-blue-300">
                Clique aqui
              </a>
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login